import styled from 'styled-components';
import { black, beige } from 'theme/colors';
import { Paragraph } from 'components/ui/Typography';

export const Expander = styled.div`
	display: flex;
	padding: 0.1rem 0;
	position: relative;

	&::before {
		display: inline-block;
		position: absolute;
		content: '';
		height: 0.1rem;
		width: 100%;
		background-color: ${black};
		top: 1.5rem;
	}
`;

export const Div = styled.div`
	margin: 0 auto;
	z-index: 100;
	padding: 0 2rem;
	background: ${beige};
`;

export const ShowMore = styled(Paragraph)`
	font-weight: 700;
	margin: 0 0.2rem 0 0;
	color: ${black};
	display: inline-block;
`;

export const Link = styled.a`
	text-decoration: none;

	&:hover ${ShowMore} {
		text-decoration: underline;
	}
`;
